import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';
import { FormattedMessage } from '@nykaa/intl-shared';

interface TabProps {
  [key: string]: number;
}
interface TabsProps {
  list: TabProps;
  activeTab: number;
  onTabClick: (index: number) => void;
}

interface ActiveTabProps {
  color: string;
}

const Wrapper = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-left: 0;
  display: flex;
  justify-content: space-around;
`;

const Tab = styled.h2`
  text-align: center;
  display: inline-block;
  font-weight: 500;
  padding: 15px 2px;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.subTitleMedium};

  &.active {
    color: ${({ color }: ActiveTabProps) => color};
    border-bottom: 2px solid ${({ color }: ActiveTabProps) => color};
  }
`;

const Tabs = ({ list, onTabClick, activeTab = 0 }: TabsProps) => {
  const theme: Theme = useTheme();
  return (
    <Wrapper role="tablist">
      {Object.keys(list).map((key: string, index: number) => {
        const isActive = activeTab === index;
        return (
          <Tab
            key={`tabs-${index}`}
            className={`${isActive ? 'active' : ''}`}
            onClick={() => onTabClick(index)}
            color={theme.brandPrimary}
            role="tab"
            tabIndex={isActive ? 0 : -1}
            aria-selected={isActive}
          >
            <FormattedMessage id={key} />
          </Tab>
        );
      })}
    </Wrapper>
  );
};

export default Tabs;
